import { inject, Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { LoadingService } from '@portal/loading/data-access';
import { finalize } from 'rxjs';
import { LeadSubmissionResponse } from '../type/lead.type';
import { LeadApiService } from '../api/lead-api.service';

@Injectable({ providedIn: 'root' })
export class LeadSubmissionResolver implements Resolve<LeadSubmissionResponse> {
  private readonly api = inject(LeadApiService);
  private readonly loadingService = inject(LoadingService);

  resolve() {
    this.loadingService.show();
    return this.api.detailSubmission().pipe(finalize(() => this.loadingService.hide()));
  }
}
